export default {
  transWhite: 'rgba(255,255,255,.7)',
  white: '#fff',
  green: '#47bb3c',
  accent: '#e0197d',
  red: '#d63636',
  yellow: '#eab127'
}
